import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle, faBuilding } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserCheck } from '@fortawesome/free-solid-svg-icons/faUserCheck'

library.add(faUserSecret, faFileExcel, faTimesCircle, faBuilding, faUserCheck)

Vue.component('font-awesome-icon', FontAwesomeIcon)
